module.exports = __webpack_public_path__ + "Roboto-Regular.df7b648ce5356ea1ebce.ttf";


//////////////////
// WEBPACK FOOTER
// C:/ProactiView/ProactiView-Client/src/libs/mdbootstrap/font/roboto/Roboto-Regular.ttf
// module id = ../../../../../src/libs/mdbootstrap/font/roboto/Roboto-Regular.ttf
// module chunks = styles